<template>
    <div class="">
        <Header></Header>
        <div class="page-container">
            <div class="page-wrapper">
                <div class="page-back-wrapper">
                    <div class="page-back" @click="handleBack">
                        <img src="@/assets/img/back.png" alt="" class="page-back-img">
                        <span>返回</span>
                    </div>
                </div>

                <div class="page-content-container">
                    <div class="page-content-header">
                        <div class="page-header-block"></div>
                        <div class="page-content-header-item">
                            <span style="margin-left:46px;">{{ basicInfo.planName }}</span>
                        </div>
                    </div>
                    <div class="page-header-content-wrapper">
                        <div class="page-header-content">
                            <img src="@/assets/img/clock3.png" alt="" class="header-img">
                            <div class="page-header-content-label">
                                学习期限：{{ basicInfo.planStartTime }} 至 {{ basicInfo.planEndTime }}
                            </div>
                        </div>
                    </div>
                    <div class="page-header-content-wrapper" style="margin-top:10px;">
                        <div class="page-header-content">
                            <img src="@/assets/img/text.png" alt="" class="header-img2">
                            <div class="page-header-content-label">
                                计划宗旨：{{ basicInfo.planPurpose }}
                            </div>
                        </div>
                    </div>

                    <div class="tab-container">
                        <div class="tab-wrapper">
                            <div class="tab-header">
                                <div v-for="(item, key) in tabArr" :key="key" @click="handleTab(item.id)"
                                    :class="activeTab == item.id ? 'tab-header-item-active' : 'tab-header-item'">
                                    {{ item.label }}
                                    <div v-if="activeTab == item.id" class="tab-line-wrapper">
                                        <div class="tab-line"></div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="tableData.length > 0" style="min-height:500px;">
                                <div v-for="(item, key) in tableData" :key="key" class="table-container">
                                    <div v-if="activeTab == 'course-list'" class="table-content">
                                        <div class="table-header">
                                            {{ item.courseName }}
                                        </div>
                                        <div class="table-date">
                                            视频
                                            <div class="table-date-line"></div>
                                            {{ item.courseTime }}分钟
                                        </div>
                                        <div v-if="activeMode == 'edit'" class="table-info-wrapper">
                                            <div class="table-info-item">
                                                <div class="table-info-title">要求进度</div>
                                                <div class="table-info-value">
                                                    <span v-if="item.requiredProgress == 100" style="color:#FF9645;">
                                                        {{ item.requiredProgress }}%
                                                    </span>
                                                    <span v-else style="color:#3E63EE;">
                                                        {{ item.requiredProgress }}%
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="table-info-item">
                                                <div class="table-info-title">学习进度</div>
                                                <div class="table-info-value">
                                                    <span v-if="item.studyProgress == 100" style="color:#FF9645;">
                                                        {{ item.studyProgress }}%
                                                    </span>
                                                    <span v-else style="color:#3E63EE;">
                                                        {{ item.studyProgress }}%
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="table-info-item">
                                                <div class="table-info-title">上次学习</div>
                                                <div class="table-info-value">
                                                    {{ item.lastStudyTime }}
                                                </div>
                                            </div>
                                            <div class="table-info-item">
                                                <div class="table-info-title">完成日期</div>
                                                <div class="table-info-value">
                                                    {{ item.finishedTime }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="activeTab == 'stage-test'" class="table-content">
                                        <div class="table-header">
                                            {{ item.metaExamName }}
                                        </div>
                                        <div class="table-date">
                                            测试时长
                                            <div class="table-date-line"></div>
                                            {{ item.metaExamTime }}分钟
                                        </div>
                                    </div>
                                    <div v-if="activeTab == 'synthesis-measure'" class="table-content">
                                        <div class="table-header">
                                            {{ item.metaExamName }}
                                        </div>
                                        <div class="table-date">
                                            测试时长
                                            <div class="table-date-line"></div>
                                            {{ item.metaExamTime }}分钟
                                        </div>
                                    </div>
                                    <div v-if="activeTab == 'course-list'" class="table-operate">
                                        <div v-if="activeMode == 'edit'" class="table-btn" @click="handleKeepStudy(item)">
                                            继续学习
                                        </div>
                                    </div>
                                    <div v-if="activeTab == 'stage-test'" class="table-operate">
                                        <div v-if="item.examStatus == 0" class="table-btn-state">未开始</div>
                                        <div v-if="item.examStatus == 1" class="table-btn-state examStatus1">进行中</div>
                                        <div v-if="item.examStatus == 2" class="table-btn-state examStatus2">已完成</div>
                                        <!-- <div v-if="activeMode == 'edit' && basicInfo.skipCourse != 1" class="table-btn"
                                            @click="viewCourseRule(item)"
                                            :disabled="basicInfo.skipCourse == 1 ? true : false">
                                            课程要求 {{ }}
                                        </div> -->
                                        <el-button :disabled="basicInfo.skipCourse == 1 ? true : false"
                                            @click="viewCourseRule(item)" v-if="activeMode == 'edit'" class="table-btn"
                                            style="height: 43px;">课程要求</el-button>
                                        <div v-if="activeMode == 'edit'"
                                            :class="`table-btn ${item.examStatus == 0 ? 'not-into' : ''}`"
                                            @click="handlePartTest(item)">进入测评</div>
                                    </div>
                                    <div v-if="activeTab == 'synthesis-measure'" class="table-operate">
                                        <div v-if="item.examStatus == 0" class="table-btn-state">未开始</div>
                                        <div v-if="item.examStatus == 1" class="table-btn-state examStatus1">进行中</div>
                                        <div v-if="item.examStatus == 2" class="table-btn-state examStatus2">已完成</div>
                                        <div v-if="activeMode == 'edit'"
                                            :class="`table-btn ${item.examStatus == 0 ? 'not-into' : ''}`"
                                            @click="handleTotalTest(item)">进入测评</div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="no-data-wrapper">
                                <img src="@/assets/img/nodata.png" alt="" class="no-data-img">
                                <div class="no-data-label">
                                    暂无<span v-for="(item, key) in tabArr" :key="key">
                                        <span v-if="item.id == activeTab">{{ item.label }}</span>
                                    </span>！
                                </div>
                            </div>
                            <!--<div class="pagination-wrapper">
                                <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :current-page="currentPage"
                                    :total="totalRows"
                                    @currentPage="handlePage">
                                </el-pagination>
                            </div>-->
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <el-dialog title="" :show-close="true" width="524px" :visible.sync="tipsDialog" class="dialog-container">
            <div class="dialog-header">
                <div>温馨提示</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-info">
                    <!-- 只有一次机会-未做 -->
                    <span
                        v-if="partExamInfo.remainingTimes === 1 && partExamInfo.totalTimes === 1 && partExamInfo.totalTimes === partExamInfo.remainingTimes">
                        本次测评只有一次机会，交卷后分数将计入排名，是否进入考试？
                    </span>
                    <!-- 只有一次机会-已提交 -->
                    <span
                        v-else-if="partExamInfo.remainingTimes === 0 && partExamInfo.totalTimes === 1 && partExamInfo.totalTimes > partExamInfo.remainingTimes">
                        本次测评共有1次机会，您还剩余0次考试，分数已计入排名，可查看测评报告
                    </span>
                    <!-- 有多次机会已全部用完-已提交 -->
                    <span v-else-if="partExamInfo.remainingTimes === 0 && partExamInfo.totalTimes > 1">
                        本测评共有{{ partExamInfo.totalTimes }}次机会，排名将选取考试的最高分，您将剩余{{ partExamInfo.remainingTimes
                        }}次机会，可选择重新测试或者查看上一次测评报告
                    </span>
                    <!-- 有多次机会-未提交 -->
                    <span
                        v-else-if="partExamInfo.totalTimes > 1 && partExamInfo.totalTimes === partExamInfo.remainingTimes">
                        本测评共有{{ partExamInfo.totalTimes }}次机会，排名将选取考试的最高分，您将剩余{{ partExamInfo.remainingTimes }}次机会，是否进入答题？
                    </span>
                    <!-- 有多次机会-已提交 -->
                    <span v-else-if="partExamInfo.totalTimes > 1 && partExamInfo.totalTimes > partExamInfo.remainingTimes">
                        本测评共有{{ partExamInfo.totalTimes }}次机会，排名将选取考试的最高分，您将剩余{{ partExamInfo.remainingTimes
                        }}次机会，可选择重新测试或者查看上一次测评报告
                    </span>
                    <span v-else>
                        你已参与考试，排名将选取最高分，您还剩余{{ partExamInfo.remainingTimes }}次考试，是否进入答题？
                    </span>
                </div>
                <div
                    :class="`dialog-btn-wrapper ${!setEnterExerciseShow() || !setViewExerciseShow() ? 'one-btn-wrapper' : ''}`">
                    <el-button @click="viewExercise" v-if="setViewExerciseShow()">查看报告</el-button>
                    <el-button type="primary" @click="enterExercise" v-if="setEnterExerciseShow()"
                        :disabled="!setIntoExercise()">进入考试</el-button>
                </div>
            </div>
        </el-dialog>

        <!--课程要求-->
        <el-dialog title="" :show-close="true" width="1044px" :visible.sync="courseRuleDialog" class="dialog-container">
            <div class="dialog-header">
                <div>课程要求</div>
            </div>
            <div class="dialog-content">
                <div v-for="(item, key) in courseRuleData" :key="key" class="course-rule-container">
                    <div class="course-rule-wrapper">
                        <div class="course-rule-title">
                            {{ item.courseName }}
                        </div>
                        <div class="course-rule-brief">
                            <div class="course-rule-brief-label">视频</div>
                            <div class="course-rule-line"></div>
                            <div>{{ item.courseTime }}分钟</div>
                        </div>
                        <div class="course-rule-content">
                            <div>
                                <div>需求进度</div>
                                <div class="course-rule-content-val" style="color:#3E63EE;">
                                    {{ item.requiredProgress }}%
                                </div>
                            </div>
                            <div class="course-rule-content-line"></div>
                            <div>
                                <div>学习进度</div>
                                <div class="course-rule-content-val" style="color:#FF9645;">
                                    {{ item.studyProgress }}%
                                </div>
                            </div>
                            <div class="course-rule-content-line"></div>
                            <div>
                                <div>上次学习</div>
                                <div class="course-rule-content-val">{{ item.lastStudyTime }}</div>
                            </div>
                            <div class="course-rule-content-line"></div>
                            <div>
                                <div>完成日期</div>
                                <div class="course-rule-content-val">{{ item.finishedTime }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="course-rule-btn" @click="ruleKeepStudy(item)">继续学习</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import {
    planBasicInfo,
    hasSelectedCourse,
    myPlanCourseList,
    partTestList,
    myPartPlanList,
    myTotalPlanList,
    totalPlanList,
    myPartTestInfo,
    myTotalTestInfo,
    myStageExamStudyCourseList,
    userLastStageExamReport,
    userLastExamReport,
    courseAuth
} from '@/api/index.js';
export default {
    name: '',
    components: {
        Header
    },
    data() {
        return {
            dept: '',
            token: '',
            activeMode: '',
            activePlan: '',
            activeTab: 'course-list',
            basicInfo: {},
            tabArr: [
                {
                    id: 'course-list',
                    label: '课程列表'
                },
                {
                    id: 'stage-test',
                    label: '阶段测试'
                },
                {
                    id: 'synthesis-measure',
                    label: '综合测评'
                }
            ],
            tableData: [],
            currentPage: 1,
            totalRows: 0,
            tipsDialog: false,
            partExamInfo: {},
            activeTestRow: {},
            courseRuleDialog: false,
            testMode: 'part',
            courseRuleData: []
        }
    },
    mounted() {
        this.dept = window.localStorage.getItem('dept');
        this.token = window.localStorage.getItem('token');
        this.activeMode = this.$route.params.mode;
        this.activePlan = this.$route.params.id;
        this.getBasicInfo();
        this.handleTab('course-list');
    },
    methods: {
        handleBack() {
            // this.$router.push(`/`);
            this.$router.go(-1);

            // var activeMode=this.activeMode;
            // if(activeMode=='detail'){
            //     this.$router.push(`/studyplan/manage-plan`);
            // }else{
            //     this.$router.push(`/studyplan/my-plan`);
            // }
        },
        getBasicInfo() {
            var planId = this.activePlan;
            planBasicInfo(planId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.basicInfo = data;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        handleTab(target) {
            this.activeTab = target;
            this.currentPage = 1;
            this.tableData = [];
            this.getTableData();
        },
        getTableData() {
            var activeTab = this.activeTab;
            var activeMode = this.activeMode;
            switch (activeTab) {
                case 'course-list':
                    if (activeMode == 'detail') {
                        this.getDetailCourseList();
                    }
                    if (activeMode == 'edit') {
                        this.getMyCourseList();
                    }
                    break;
                case 'stage-test':
                    if (activeMode == 'detail') {
                        this.getPartTestList();
                    }
                    if (activeMode == 'edit') {
                        this.getMyPartPlan();
                    }
                    break;
                case 'synthesis-measure':
                    if (activeMode == 'detail') {
                        this.getTotalTestList();
                    }
                    if (activeMode == 'edit') {
                        this.getMyTotalPlan();
                    }
                    break;
            }
        },
        getDetailCourseList() {
            hasSelectedCourse({
                "deptId": this.dept,
                "keyword": "",
                "pageNum": this.currentPage,
                "pageSize": 10000,
                "planId": this.activePlan,
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data.list;
                    this.totalRows = res.data.totalRecords;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        getMyCourseList() {
            myPlanCourseList({
                "deptId": this.dept,
                "keyword": "",
                "pageNum": this.currentPage,
                "pageSize": 10000,
                "planId": this.activePlan,
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data.list;
                    this.totalRows = res.data.totalRecords;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        getMyPartPlan() {
            myPartPlanList(this.activePlan, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        getPartTestList() {
            partTestList(this.activePlan, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        getMyTotalPlan() {
            myTotalPlanList(this.activePlan, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        getTotalTestList() {
            totalPlanList(this.activePlan, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        handlePage(num) {
            this.currentPage = num;
            this.getTableData();
        },
        handlePartTest(row) {
            this.testMode = 'part';
            this.activeTestRow = row;
            myPartTestInfo(row.metaExamId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    // if(data.remainingTimes>0){
                    this.partExamInfo = res.data;
                    this.tipsDialog = true;
                    // }else{
                    // this.$message({
                    //     message: '您的答题次数已用完',
                    //     type: 'warning'
                    // });
                    // }
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        handleTotalTest(row) {
            this.testMode = 'total';
            this.activeTestRow = row;
            myTotalTestInfo(row.metaExamId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    // if(data.remainingTimes>0){
                    this.partExamInfo = res.data;
                    this.tipsDialog = true;
                    // }else{
                    // this.$message({
                    //     message: '您的答题次数已用完',
                    //     type: 'warning'
                    // });
                    // }
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        viewExercise() {
            var row = this.activeTestRow;
            var metaExamId = row.metaExamId;
            var planId = this.activePlan;
            var testMode = this.testMode;
            var modeVal;
            if (testMode == 'part') {
                modeVal = 'partEdit';
            }
            if (testMode == 'total') {
                modeVal = 'totalEdit';
            }
            let isRetest = true // 是否可以重新测试
            isRetest = this.setIntoExercise()
            var exercise = {
                mode: modeVal,
                title: row.metaExamName,
                info: row,
                // intoExerciseType: 'viewExercise',
                partExamInfo: this.partExamInfo, // 获取测试基本信息
            }
            window.localStorage.setItem('exercise', JSON.stringify(exercise));
            let reMethods = userLastStageExamReport // 阶段测试
            if (this.activeTab === 'synthesis-measure') { // 综合测试
                reMethods = userLastExamReport
            }
            reMethods(metaExamId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    data['palnId'] = planId;
                    data["title"] = exercise.title;
                    data["isRetest"] = isRetest; // 是否可以重新测试
                    window.localStorage.setItem('score', JSON.stringify(data));
                    this.$router.push(`/exerciseScore`);
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
            // this.$router.push(`/exerciseScore`);
            // this.$router.push(`/exercise/${planId}/${metaExamId}`);
        },
        enterExercise() {
            var row = this.activeTestRow;
            var metaExamId = row.metaExamId;
            var planId = this.activePlan;
            var testMode = this.testMode;
            var modeVal;
            if (testMode == 'part') {
                modeVal = 'partEdit';
            }
            if (testMode == 'total') {
                modeVal = 'totalEdit';
            }
            var exercise = {
                mode: modeVal,
                title: row.metaExamName,
                info: row,
                intoExerciseType: 'enterExercise',
                partExamInfo: this.partExamInfo, // 获取测试基本信息
            }
            window.localStorage.setItem('exercise', JSON.stringify(exercise));
            this.$router.push(`/exercise/${planId}/${metaExamId}`);
        },
        viewCourseRule(row) {
            //console.log(row);
            myStageExamStudyCourseList({
                deptId: this.dept,
                keyword: '',
                metaExamId: row.metaExamId,
                pageNum: 1,
                pageSize: 10000,
                planId: this.activePlan,
                userId: 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.courseRuleData = res.data.list;
                    this.courseRuleDialog = true;
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        ruleKeepStudy(row) {
            var planData = {
                id: this.activePlan
            }
            window.localStorage.setItem('plan', JSON.stringify(planData));
            this.$router.push(`/courseDetail/plan/${row.courseId}/${this.dept}/${row.courseType}`);
        },
        handleKeepStudy(row) {
            courseAuth(row.courseId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var planData = {
                        id: this.activePlan
                    };
                    window.localStorage.setItem('plan', JSON.stringify(planData));
                    this.$router.push(`/courseDetail/plan/${row.courseId}/${this.dept}/${row.courseType}`);
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        // 设置进入考试展示
        setEnterExerciseShow() {
            let showFlag = true;
            let partExamInfo = this.partExamInfo
            if (partExamInfo.remainingTimes === 0 && partExamInfo.totalTimes === 1 && partExamInfo.totalTimes > partExamInfo.remainingTimes) {
                showFlag = false
            } else if (partExamInfo.remainingTimes === 0 && partExamInfo.totalTimes > 1) {
                showFlag = false
            }
            return showFlag
        },
        // 设置报告考试展示
        setViewExerciseShow() {
            let showFlag = true;
            let partExamInfo = this.partExamInfo
            if (partExamInfo.remainingTimes === 1 && partExamInfo.totalTimes === 1 && partExamInfo.totalTimes === partExamInfo.remainingTimes) {
                showFlag = false
            } else if (partExamInfo.totalTimes > 1 && partExamInfo.totalTimes === partExamInfo.remainingTimes) {
                showFlag = false
            }
            return showFlag
        },
        // 设置能否进去考试，超出结束时间不给点击
        setIntoExercise() {
            let flag = true
            if (this.basicInfo.planEndTime) {
                var endtime = this.basicInfo.planEndTime.replace("/-/g", "/");//时间转换
                // 时间
                var date1 = new Date(endtime);
                // 现在时间
                var date2 = new Date();
                // 判断计划是否开始
                flag = date1 < date2 ? false : true;
            }
            return flag
        },
    }
}
</script>

<style scoped>
.page-container {
    width: 100%;
    margin: 0 auto;
}

.page-wrapper {
    width: 1200px;
    margin: 0 auto;
    padding: 100px;
}

.page-back-wrapper {
    width: 100%;
    height: 68px;
    background: #ffffff;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #f0f0f3;
    display: flex;
    align-items: center;
    margin-top: 18px;
}

.page-back-img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    display: inline-block;
    position: relative;
    top: 2px;
}

.page-back {
    display: flex;
    align-items: center;
    margin-left: 30px;
    cursor: pointer;
}

.page-content-container {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    margin-top: 18px;
}

.page-content-header {
    width: 100%;
    height: 80px;
    background: #F8FAFF;
    border-radius: 6px 5px 0px 0px;
    line-height: 80px;
    position: relative;
}

.page-header-block {
    width: 6px;
    height: 24px;
    background: #4F79ED;
    border-radius: 0px 17px 17px 0px;
    position: absolute;
    left: 0px;
    top: 28px;
}

.page-content-header-item {
    width: 100%;
    height: 100%;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4F79ED;
    background: #fff;
    cursor: pointer;
}

.page-header-content-wrapper {
    display: flex;
}

.page-header-content {
    flex: 1;
    margin: 0px 46px 0px 46px;
    display: flex;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6D7A86;
}

.header-img {
    width: 21px;
    height: 21px;
}

.header-img2 {
    width: 19px;
    height: 19px;
    display: inline-block;
    position: relative;
    top: 1px;
    left: 1px;
    margin-right: 1px;
}

.page-header-content-label {
    margin-left: 10px;
}

.tab-container {
    display: flex;
    margin-top: 78px;
}

.tab-wrapper {
    flex: 1;
    margin: 0px 46px 50px 46px;
}

.tab-header {
    display: flex;
    padding-bottom: 12px;
    border-bottom: 1px solid #F0F0F0;
}

.tab-header-item {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    margin-right: 34px;
    position: relative;
}

.tab-header-item-active {
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #666666;
    margin-right: 34px;
    position: relative;
    cursor: pointer;
}

.tab-header-item:hover {
    cursor: pointer;
}

.tab-line-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: -13px;
    left: 0px;
}

.tab-line {
    width: 22px;
    height: 6px;
    background: #3E63EE;
    border-radius: 3px;
}

.table-container {
    display: flex;
    justify-content: space-between;
    padding-top: 35px;
    padding-bottom: 29px;
    border-bottom: 1px solid #F0F0F0;
}

.table-content {
    width: 726px;
}

.table-header {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
}

.table-date {
    margin-top: 8px;
    display: flex;
    align-content: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
}

.table-date-line {
    width: 1px;
    height: 14px;
    background: #D7D7D7;
    margin: 0px 8px 0px 8px;
    position: relative;
    top: 4px;
}

.table-info-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
}

.table-info-item {
    flex: 1;
    color: #606A74;
}

.table-info-title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
}

.table-info-value {
    margin-top: 6px;
}

.table-btn {
    width: 108px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #3E63EE;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3E63EE;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 11px;
    margin-left: 20px;
}

.table-btn:hover {
    cursor: pointer;
    background: #3E63EE;
    color: #fff;
}

.table-btn-state {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-top: 6px;
}

.pagination-wrapper {
    text-align: center;
    margin-top: 76px;
}

.dialog-container>>>.el-dialog__body {
    padding: 0px !important;
}

.dialog-container>>>.el-dialog__header {
    padding: 0px !important;
}

.dialog-header {
    width: 100%;
    height: 59px;
    background: #F8FAFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
}

.dialog-content {
    padding: 46px 77px 60px 77px;
}

.dialog-btn-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
}

.one-btn-wrapper {
    justify-content: center;
}

.dialog-content>>>.el-button {
    width: 148px !important;
    height: 40px !important;
    line-height: 40px !important;
    border-radius: 6px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 18px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
}

.dialog-content>>>.el-button--primary {
    background: linear-gradient(90deg, #5580F5 0%, #72A3F5 100%) !important;
}

.dialog-content>>>.el-button--default {
    border: 1px solid #4F79ED;
    color: #4F79ED !important;
}

.no-data-wrapper {
    min-height: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.no-data-label {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666;
    margin-top: 20px;
}

.table-operate {
    display: flex;
    align-items: center;
}

.table-operate .not-into {
    pointer-events: none;
    color: #c0c4cc;
    border-color: #c0c4cc;
}

.examStatus1 {
    color: #67C23A;
}

.examStatus2 {
    color: #FF9645;
}

.course-rule-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}

.course-rule-wrapper {
    width: 726px;
    position: relative;
}

.course-rule-brief {
    display: flex;
    margin-top: 8px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
}

.course-rule-brief-label {
    width: 40px;
    margin-right: 8px;
}

.course-rule-line {
    width: 1px;
    height: 14px;
    background: #D7D7D7;
    margin-right: 10px;
    position: relative;
    top: 4px;
}

.course-rule-content {
    display: flex;
    margin-top: 16px;
    padding-bottom: 29px;
    border-bottom: solid #F0F0F0 1px;
}

.course-rule-title {
    width: 100%;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.course-rule-content-line {
    width: 1px;
    height: 35px;
    background: #E4E4E4;
    margin-left: 43px;
    margin-right: 43px;
}

.course-rule-content-val {
    font-size: 18px;
    margin-top: 5px;
}

.course-rule-btn {
    width: 108px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #3E63EE;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3E63EE;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.course-rule-btn:hover {
    cursor: pointer;
    background: #3E63EE;
    color: #fff;
}
</style>


